import MultiForm from '@admin/components/multiform'
import PropTypes from 'prop-types'
import Customer from './customer'
import Invoices from './invoices'
import Details from './details'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(New Payment)',
      action: '/api/admin/finance/payments',
      method: 'POST',
      formatData: this._getData.bind(this),
      getSteps: this._getSteps.bind(this),
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getData(formdata) {
    return {
      allocations: formdata.allocations,
      date: formdata.date,
      payment: formdata.payment      
    }
  }

  _getSteps(formdata) {
    return [
      { label: 't(Customer)', component: Customer },
      { label: 't(Invoices)', component: Invoices },
      { label: 't(Details)', component: Details }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(campaign) {
    this.context.modal.close()
  }

}

export default New
